import { Checkbox, FormControlLabel } from '@mui/material';
import React from 'react';
import { Controller } from 'react-hook-form';

import { WHEAT } from 'constants/ColorForm';
import { BG_POSITION } from 'constants/ColorMap';

function CustomCheckboxYup({ errors, register, setValue, control, name, defaultValue, label }) {
  return (
    <Controller
      render={({ field: { onChange } }) => (
        <FormControlLabel
          control={
            <Checkbox
              onChange={(e) => {
                onChange(e.target.checked);
                setValue(name, e.target.checked)
              }}
              sx={{
                color: WHEAT,
                '&.Mui-checked': {
                  color: BG_POSITION[0],
                },
              }}
              checked={defaultValue}
            />
          }
          label={label}
        />
      )}
      name={name}
      control={control}
      defaultValue={defaultValue}
    />
  );
}

export default CustomCheckboxYup;
